// A color picker preview where you can choose to have the color or backgroundColor
// get updated based on the result of a color picker. It also supports ensuring
// the foreground text is always readable by performing a YIQ calculation to
// set the text to black or white based on the contrast of the color and backgroundColor.

import { Controller } from "@hotwired/stimulus";

export default class ColorableController extends Controller {
  static targets = ["preview", "color"];

  static values = {
    style: {
      default: "backgroundColor",
      type: String,
    },
  };
  declare readonly colorTarget: HTMLInputElement;
  declare readonly colorTargets: HTMLInputElement[];
  declare readonly hasColorTarget: boolean;
  declare readonly hasPreviewTarget: boolean;
  declare readonly hasStyleValue: boolean;

  declare readonly previewTarget: HTMLDivElement;

  declare readonly previewTargets: HTMLDivElement[];
  declare styleValue: string;

  private getContrastYIQ(hexColor: string): string {
    // Taken from: https://24ways.org/2010/calculating-color-contrast/
    hexColor = hexColor.replace("#", "");

    const yiqThreshold = 128;
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 2), 16);
    const b = parseInt(hexColor.substring(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= yiqThreshold ? "#000" : "#fff";
  }

  preview(color: string): void {
    this.previewTarget.style[this.styleValue as unknown as number] = color;

    // Ensure the foreground text is always readable by setting either the
    // backgroundColor or color to black or white.
    const yiqColor = this.getContrastYIQ(color);

    if (this.styleValue === "color") {
      this.previewTarget.style.backgroundColor = yiqColor;
    } else {
      this.previewTarget.style.color = yiqColor;
    }
  }

  update(): void {
    this.previewTarget.innerText = this.colorTarget.value;
  }
}
